type QueryValue = string | number | undefined | null;

const appendParams = (
  query: URLSearchParams,
  values: Record<string, QueryValue>,
  prefix?: string,
) => {
  Object.entries(values).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(prefix ? `${prefix}[${key}]` : key, String(value));
  });
};

/**
 * Construit une URL crawlable (ex: pagination, filtres) en combinant des
 * paramètres simples et un objet `search` imbriqué au format Rails (`search[key]`).
 */
export const buildSearchUrl = (
  basePath: string,
  params: Record<string, QueryValue> = {},
  search?: Record<string, QueryValue>,
) => {
  const query = new URLSearchParams();
  appendParams(query, params);
  if (search) appendParams(query, search, "search");

  const queryString = query.toString();
  return queryString ? `${basePath}?${queryString}` : basePath;
};
